import type { Emergency } from 'src/models/extLandApEmergency';

export interface EmergencyResponse {
  id: number;
  camera_id: number;
  car_kind: string;
  comment?: string | null;
  device_id: string;
  device_name: string;
  direction: string;
  driver_id: string;
  duration: number;
  emergencies_link: string;
  event_ts: string;
  landmark_disp?: string;
  local_address?: string;
  lat: number;
  lon: number;
  media_type: number;
  movie_path: string;
  movie_type: number;
  movie_type_disp: string;
  ts: string;
}

export type EmergencyIndexResponse = EmergencyResponse[];

export const toEmergency = (response: EmergencyResponse): Emergency => ({
  id: response.id,
  cameraId: response.camera_id,
  carKind: response.car_kind,
  comment: response.comment ?? null,
  deviceId: response.device_id,
  deviceName: response.device_name,
  direction: response.direction,
  driverId: response.driver_id,
  duration: response.duration,
  emergenciesLink: response.emergencies_link,
  eventTs: response.event_ts,
  landmarkDisp: response.landmark_disp ?? null,
  localAddress: response.local_address ?? null,
  location: { lat: response.lat, lon: response.lon },
  mediaType: response.media_type,
  moviePath: response.movie_path,
  movieType: response.movie_type,
  movieTypeDisp: response.movie_type_disp,
  ts: response.ts,
});
